import { defineMessage } from 'services/localization';

export const messages = {
    amaxPayBankAccountFieldName: defineMessage('bank_account'),
    allowToRemoveLinesFromBP: defineMessage('allow_to_remove_lines_from_the_batch_payment'),
};
